export default {
  state: {
    nowDate: null,            // 当前时间的时间戳
    timeDifference: 0,        // 和服务端时间差
    SubListUpdate: false,     // 任务的任务列表(子任务列表)是否更新
    subHeaderInfo: {},        // 子任务列表头部
    subList: [],              // 子任务列表
    activityMessage: 0,        // 活动广场小心数量
    timeDiff: 0, // 本地时间和服务器时间差
    hideGlobalHeader: false // 活动详情页滚动后隐藏全局 Header
  },
  mutations: {
    set_SubListUpdate (state) {
      state.SubListUpdate = !state.SubListUpdate
    },
    set_subHeaderInfo (state, val) {
      state.subHeaderInfo = val
    },
    set_nowDate (state, val) {
      state.nowDate = val
    },
    set_subList (state, val) {
      state.subList = val
    },
    set_timeDifference (state, val) {
      state.timeDifference = val
    },
    set_activityMessage (state, val) {
      state.activityMessage = val
    },
    setDiff (state, val) {
      state.timeDiff = val
    },
    set_hideGlobalHeader (state, val) {
      state.hideGlobalHeader = !!val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/common.js